import React from "react";
import Footer from "../layout/Footer";
import Header from "../layout/Header";
import { ORIENTATION_SOURCE_OPTIONS } from "./orientationSources";

/**
 * Discontinuity-orientation source selection: its own screen between the
 * activity card and the guided input form, one input table per choice.
 */
const CARD_DETAILS = {
  known: {
    icon: "fas fa-compass color-magenta-dark",
    blurb: "Plot the trace from known Dip Direction and Dip Amount",
  },
  facelogs: {
    icon: "fas fa-clone color-highlight",
    blurb: "Compute the orientation from the logs of two tunnel faces, then plot",
  },
  chainages: {
    icon: "fas fa-ruler color-green-dark",
    blurb: "Compute the orientation from known chainages of the trace, then plot",
  },
};

const SourceSelect = (props) => (
  <div id="page">
    <Header onBack={props.showobjective} />
    <Footer />
    <div className="page-content header-clear-medium">
      <div className="row mb-0">
        <div className="col-md-12 text-center">
          <span className="m-3">How is the discontinuity orientation obtained?</span>
        </div>
      </div>
      <div className="row text-center mb-3 justify-content-center">
        {ORIENTATION_SOURCE_OPTIONS.map(({ value, label }) => (
          <a
            key={value}
            onClick={() => props.onChoose(value)}
            href="javascript:;"
            className="col-4"
          >
            <div className="card card-style mx-2 mb-3 h-100">
              <i className={`${CARD_DETAILS[value].icon} fa-3x mt-5`}></i>
              <h3 className="pt-4">{label}</h3>
              <p className="font-11 opacity-50 mt-n2">{CARD_DETAILS[value].blurb}</p>
              <p className="mb-0 pb-0 font-10 opacity-40">Tap to Select</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  </div>
);

export default SourceSelect;
